import { render } from "./No2.vue?vue&type=template&id=16675877&scoped=true&ts=true"
import script from "./No2.vue?vue&type=script&lang=ts"
export * from "./No2.vue?vue&type=script&lang=ts"

import "./No2.vue?vue&type=style&index=0&id=16675877&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16675877"]])

export default __exports__